import { css } from '@emotion/react'
import "focus-visible/dist/focus-visible"

import { mediaStyle } from './src/contexts/responsive'

const flexFullHeight = css`
flex: 1;
display: flex;
flex-direction: column;
`

export default css`
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;700;900&family=Noto+Serif+TC:wght@700&display=swap');
  html {
    height: 100%;
  }
  body {
    min-width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    letter-spacing: 1.8px;
  }
  #___gatsby {
    ${flexFullHeight}
    > #gatsby-focus-wrapper {
      ${flexFullHeight}
      > main {
        ${flexFullHeight}
        > div:not(.fresnel-container) {
          flex: 1;
        }
      }
    }
  }
  ${mediaStyle}
`;
